import { useState } from "react";
import { toast } from "react-toastify";
import { API_URL } from "../../utils/ApiUrl";
import axios from "axios";
import CustomToast from '../../components/CustomToast';


function useProofSubmit(setFilePreview,
    setFile, file, taskData, message, id, setLoader, uniqueCode, fetchPrticipateData, fetchTaskData, handleClose2, handleShow3) {

    // Updated imgeUrl function to return the URL
    const imgeUrl = async (e) => {
        setLoader(true);
        console.log(e, '/upload-image eee');
        let accessToken = localStorage.getItem("accessToken");

        // Create a FormData object to send the image
        let formData = new FormData();
        // formData.append("image", e); // Assuming 'e' is the image file
        // Append each file
        e.forEach((file, index) => {
            formData.append("image", file); // or "images[]" depending on your backend
        });
        const config = {
            method: "post",
            url: `${API_URL}metadata/upload-image`,
            headers: {
                "Content-Type": "multipart/form-data", // Correct content type for file uploads
                Authorization: `Bearer ${accessToken}`,
            },
            data: formData, // Send formData with the image file
        };

        try {
            let response = await axios(config);
            if (response) {
                // // console.log(response.data.url, 'response');
                return response.data.url; // Return the URL for further processing
            }
        } catch (error) {
            setLoader(false);
            // Extract the error message from the API response and return it
            if (error.response) {
                const apiErrorMessage =
                    error.response.data.message || error.response.data;
                console.error("API Error:", apiErrorMessage);
                return { error: apiErrorMessage }; // Return an object containing the error message
            } else {
                setLoader(false);
                console.error("Error occurred while uploading image:", error);
                return {
                    error: "An unknown error occurred while uploading the image.",
                }; // Return a default error message
            }
        }
    };

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files || []);
        if (!selectedFiles.length) return;

        const updatedDeliveryFormats = [
            "jpg", "jpeg", "png", "webp",
            ...(taskData?.deliveryFormat || []),
        ];

        const allowedExtensions = updatedDeliveryFormats.map((format) =>
            format.toLowerCase()
        );

        const validFiles = selectedFiles.filter((file) => {
            if (!file || !file.name) return false;
            const fileExtension = file.name.split(".").pop().toLowerCase();
            return allowedExtensions.includes(fileExtension);
        });

        if (validFiles.length) {
            setFile(validFiles);
            setFilePreview(validFiles.map((file) => URL.createObjectURL(file)));
        } else {
            // toast.error("Unsupported file type(s). Please upload valid files.");
             CustomToast.show('error', 'Error!', 'Unsupported file type(s). Please upload valid files.')

        }
    };


    const handleSubmit = async (IpfsHash) => {
        console.log(IpfsHash, "IpfsHash in submit fun");

        if (!file || !message) {
            // toast.warn("Please fill in the message and select a file.");
            CustomToast.show('warning', 'Warning!', 'Please fill in the message and select a file.')





            return;
        }
        let accessToken = localStorage.getItem("accessToken");
        // Step 1: Upload the file to get the URL or an error
        let uploadedImageResponse = await imgeUrl(file); // Call the function to upload the image and get the URL or error

        // Step 2: Check if the response contains an error
        if (uploadedImageResponse && uploadedImageResponse.error) {
            // toast.error(`Failed to upload the file: ${uploadedImageResponse.error}`);
            CustomToast.show('error', 'Error!', `Failed to upload the file: ${uploadedImageResponse.error}`)
            setLoader(false);
            return;
        }

        // If no error, get the uploaded image URL
        let uploadedImageUrl = uploadedImageResponse;

        // Step 3: Prepare data for the PATCH request
        const dataToSubmit = {
            taskId: id,
            message: message,
            uniqueCode: uniqueCode, // Replace with the actual unique code if it's dynamic
            proofIpfsHash: `ipfs://${IpfsHash}/`,
            proofOfWork: [uploadedImageUrl], // Add the uploaded image URL to this array

            // title: "staging",
            // description: "<p>Lorem minim sequi am.</p>",
            // requirements: "<p>Dicta illum, nesciun.</p>",
            // additionalRequest: "<p>Perferendis dolore a.</p>",
            // deliveryFormat: ["jpg", "jpeg", "png"],
            // timeZone: "Asia/Karachi",
            // taskTransactionHash: "0xe1f34d950cbf5ab8ad020ac1fb337513173e76bc2cc5881502bd16585477b888",
            // reward: 42,
            // categoryId: 1,
            // contractTaskId: "90",
            // disputeType: "mini",
            // currency: "USDT",
            // currencySymbol: "USDT",
            // currencyAddress: "0x6fEA2f1b82aFC40030520a6C49B0d3b652A65915",
            // endTime: "2025-04-19T09:32:00.000Z",
            // serviceType: "digital",
            // proofIpfsHash: `ipfs://${IpfsHash}/`,
            // proofOfWork: [uploadedImageUrl], // Optional if API expects
            // message: message,                // Optional if API expects
            // uniqueCode: uniqueCode           // Optional if API expects
        };

        try {
            setLoader(true);
            // Replace 'your-api-endpoint' with the actual endpoint
            await axios.patch(`${API_URL}participants`, dataToSubmit, {
                headers: {
                    "Content-Type": "application/json", // Use application/json since we are sending a JSON object
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            fetchPrticipateData()
            fetchTaskData()
            handleClose2(); // Close modal after successful submission
            handleShow3();
            localStorage?.removeItem("metadataHashes");
            localStorage?.removeItem("fileHashes");
            // setLoader(false);
        } catch (error) {
            // Log detailed error response if available
            if (error.response) {
                console.error(
                    "API Error:",
                    error.response.data.message || error.response.data
                );
                setLoader(false);
                // toast.error(
                //     `Error submitting task: ${error.response.data.message || "Unknown error"
                //     }`
                // );
                CustomToast.show('error', 'Error!', `Error submitting task: ${error.response.data.message || "Unknown error"}`)

            } else {
                console.error("Error submitting the task:", error);
                setLoader(false);
                // toast.error("Failed to submit the task. Please try again.");
                CustomToast.show('error', 'Error!', 'Failed to submit the task. Please try again.')
            }
        }
    };
    return { handleSubmit, handleFileChange }
}
export default useProofSubmit;